exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-sp-components-atoms-ImageAsset-___ImageAsset__image___1e7fd {\n  height: 100%;\n  width: 100%;\n}", ""]);

// exports
exports.locals = {
	"image": "src-sp-components-atoms-ImageAsset-___ImageAsset__image___1e7fd"
};